export default "__VITE_ASSET__B2vhtD7S__"